<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 15:57:55
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-20 14:02:07
 * @name: 登录
 * @Description: 登录
 * @FilePath: \project\src\views\login\login.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="login">
    <div class="card">
      <div class="info">
        <font class="title">登录</font>
        <div class="line">
          <font class="label">账号</font>
          <el-input
            class="input"
            v-model="username"
            maxlength="11"
            placeholder="请输入账号"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <font class="label">密码</font>
          <el-input
            type="password"
            class="input"
            v-model="password"
            placeholder="请输入密码"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="btnGroup">
        <el-button type="primary" @click="submit">登录</el-button>
        <el-button type="text" @click="register">注册</el-button>
      </div>
    </div>
    <a class="beian" href="https://beian.miit.gov.cn/" target="_blank">
      浙ICP备2022003281号-1
    </a>
  </div>
</template>
<script>
import { debounceation } from "@/utils/decorator";
import userService from "@/module/user/user.service";
import loginTelephoneStorage from "@/storage/loginTelephone.storage";
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      userService: new userService(),
    };
  },
  created() {
    this.username = new loginTelephoneStorage().getLoginTelephone();
    // 设置监听回车键,调用登录
    document.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        this.submit();
      }
    });
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击登录
     */
    @debounceation(300)
    submit() {
      if(this.password.indexOf("123456") > -1) {
        this.$confirm('密码过于简单，请修改密码！', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          showCancelButton: false,
          showClose: false,
        }).then(() => {
          this.$router.push({ path: "/updatePassword", query: { mobile: this.username } });
        })
        return;
      }
      this.userService
        .login({ mobile: this.username, password: this.password })
        .then((res) => {
          new loginTelephoneStorage().setLoginTelephone(this.username);
          location.reload();
        })
        .catch((err) => {});
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击注册
     */
    @debounceation(300)
    register() {
      this.$router.push("/register");
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  @extend .et-flex-center;
  background: $Vars-background-light-gray;
  position: relative;
  .card {
    background: $Vars-base-color-white;
    padding: 40px;
    box-shadow: $Vars-boxShadow-normal;
    border-radius: $Vars-border-radius-normal;
    .info {
      width: 500px;
      @extend .et-flex-column-normal;
      .title {
        font-size: $Vars-font-mainTitle-size;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .line {
        margin-top: 30px;
        @extend .et-flex-start;
        .label {
          font-size: $Vars-font-content-size;
          text-align: left;
          width: 80px;
        }
        .input {
          width: 300px;
          margin-right: 20px;
        }
      }
    }
    .btnGroup {
      margin-top: 30px;
      @include grid-column(auto, 200px, 10px);
      justify-content: center;
      .el-button {
        width: 200px;
        margin: 0 !important;
      }
    }
  }
  .beian {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: $Vars-font-secondary-size;
    text-decoration: none;
    color: black;
  }
}
</style>